import { Validator, NG_VALIDATORS, ValidationErrors, AbstractControl } from '@angular/forms';
import { Input, Directive } from '@angular/core';

/** Custom Validator to check whether the currency falls between the given two range */
@Directive({
  providers: [{ provide: NG_VALIDATORS, useExisting: CurrencyBetweenTheRangeValidatorDirective, multi: true }],
  selector: '[currencyBetweenTheRangeValidation]',
  standalone: false
})
export class CurrencyBetweenTheRangeValidatorDirective implements Validator {
  /** Minimumm balance input */
  @Input() public minBalance: string;
  /** Maximumm balance input */
  @Input() public maxBalance: string;

  public validate(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      const amount = Number(control.value.replace(/[^0-9.-]+/g, ''));
      const minBalance = Number(this.minBalance.replace(/[^0-9.-]+/g, ''));
      const maxBalance = Number(this.maxBalance.replace(/[^0-9.-]+/g, ''));

      if (minBalance === 0 && maxBalance === 0) {
        return null;
      } else if (minBalance <= 0) {
        if (maxBalance > 0 && amount <= maxBalance) {
          return null;
        }
      } else if (maxBalance <= 0) {
        if (minBalance > 0 && amount >= minBalance) {
          return null;
        }
      } else {
        if (amount >= minBalance && amount <= maxBalance) {
          return null;
        }
      }

      return { currencyBetweenTheRangeValidator: false };
    }
  }
}
